import React from "react";
import "./Loader.css";
import { CDN_URLS } from "../../constants";
import { CircularProgress } from "@mui/material";

// Component Definition
const Loader = ({ spinner }) => {
  return (
    <div className="loader">
      {spinner ? (
        <CircularProgress />
      ) : (
        <img
          src={CDN_URLS.UVENU_LOADING}
          alt="Uvenu_Loading"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      )}
    </div>
  );
};

export default Loader;
